var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "child-products-section",
      class: {
        "child-products--collapsed": _vm.isCollapsed && _vm.hasMoreProducts
      }
    },
    [
      _c("div", { staticClass: "container" }, [
        _c("h2", { staticClass: "child-products-header heading h2" }, [
          _vm._v(_vm._s(_vm.sectionTitle))
        ]),
        _c(
          "div",
          { staticClass: "child-products" },
          _vm._l(_vm.childProducts, function(childProduct, index) {
            return _c("div", { staticClass: "child-products__product" }, [
              childProduct.products[0].featured_image
                ? _c("img", {
                    directives: [
                      {
                        name: "lazy",
                        rawName: "v-lazy",
                        value: childProduct.products[0].featured_image,
                        expression: "childProduct.products[0].featured_image"
                      }
                    ],
                    staticClass: "child-products__product-image",
                    attrs: { alt: `${childProduct.products[0].title} Image` }
                  })
                : _c("img", {
                    directives: [
                      {
                        name: "lazy",
                        rawName: "v-lazy",
                        value: _vm.placeholder,
                        expression: "placeholder"
                      }
                    ],
                    staticClass: "child-products__product-image",
                    attrs: { alt: "Product Placeholder Image" }
                  }),
              _c(
                "div",
                {
                  staticClass: "child-products__product-info",
                  class: `restrict_web_sale_${childProduct.products[0].tags
                    .join(",")
                    .toLowerCase()
                    .includes("restrict_web_sale")}`
                },
                [
                  _c(
                    "div",
                    { staticClass: "child-products__product-price-sku" },
                    [
                      _vm.isStudent &&
                      !_vm.thresholdReached &&
                      !childProduct.products[0].tags
                        .join(",")
                        .toLowerCase()
                        .includes("restrict_web_sale")
                        ? _c(
                            "span",
                            { staticClass: "child-products__product-price" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.getSudentPrice(
                                    childProduct.products[0].tags
                                  )
                                    ? _vm.getSudentPrice(
                                        childProduct.products[0].tags
                                      )
                                    : _vm.getRegularPrice(
                                        childProduct.products[0].variants[0]
                                      )
                                )
                              )
                            ]
                          )
                        : _vm.isStaff &&
                          !childProduct.products[0].tags
                            .join(",")
                            .toLowerCase()
                            .includes("restrict_web_sale")
                        ? _c(
                            "span",
                            { staticClass: "child-products__product-price" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.getStaffPrice(
                                    childProduct.products[0].tags
                                  )
                                    ? _vm.getStaffPrice(
                                        childProduct.products[0].tags
                                      )
                                    : _vm.getRegularPrice(
                                        childProduct.products[0].variants[0]
                                      )
                                )
                              )
                            ]
                          )
                        : _vm.isNP &&
                          !childProduct.products[0].tags
                            .join(",")
                            .toLowerCase()
                            .includes("restrict_web_sale")
                        ? _c(
                            "span",
                            { staticClass: "child-products__product-price" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.getNPPrice(childProduct.products[0].tags)
                                    ? _vm.getNPPrice(
                                        childProduct.products[0].tags
                                      )
                                    : _vm.getRegularPrice(
                                        childProduct.products[0].variants[0]
                                      )
                                )
                              )
                            ]
                          )
                        : _vm.isEP &&
                          !childProduct.products[0].tags
                            .join(",")
                            .toLowerCase()
                            .includes("restrict_web_sale")
                        ? _c(
                            "span",
                            { staticClass: "child-products__product-price" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.getEPPrice(childProduct.products[0].tags)
                                    ? _vm.getEPPrice(
                                        childProduct.products[0].tags
                                      )
                                    : _vm.getRegularPrice(
                                        childProduct.products[0].variants[0]
                                      )
                                )
                              )
                            ]
                          )
                        : !childProduct.products[0].tags
                            .join(",")
                            .toLowerCase()
                            .includes("restrict_web_sale")
                        ? _c(
                            "span",
                            { staticClass: "child-products__product-price" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("money")(
                                    childProduct.products[0].variants[0].price
                                  )
                                )
                              )
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "span",
                        { staticClass: "child-products__product-sku" },
                        [
                          _vm._v(
                            "SKU# " +
                              _vm._s(childProduct.products[0].variants[0].sku)
                          )
                        ]
                      ),
                      _c(
                        "span",
                        { staticClass: "child-products__product-sku" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.getMinQtyAboveOne(
                                  childProduct.products[0].tags
                                )
                                  ? _vm.getMinQtyAboveOne(
                                      childProduct.products[0].tags
                                    )
                                  : ""
                              )
                          )
                        ]
                      )
                    ]
                  ),
                  _c("div", { staticClass: "child-products__product-title" }, [
                    _vm._v(_vm._s(childProduct.products[0].title))
                  ])
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "child-proudcts__add-to-cart-form shopify-product-form",
                  attrs: {
                    id: `product_form_${childProduct.products[0].id}`,
                    "accept-charset": "UTF-8",
                    enctype: "multipart/form-data"
                  }
                },
                [
                  _c("input", {
                    attrs: {
                      type: "hidden",
                      name: "form_type",
                      value: "product"
                    }
                  }),
                  _c("input", {
                    attrs: { type: "hidden", name: "utf8", value: "✓" }
                  }),
                  _c("input", {
                    attrs: {
                      type: "hidden",
                      name: "id",
                      "data-sku": childProduct.products[0].variants[0].sku
                    },
                    domProps: { value: childProduct.products[0].variants[0].id }
                  }),
                  _c("input", {
                    attrs: {
                      type: "hidden",
                      name: "properties[SKU]",
                      "data-sku": childProduct.products[0].variants[0].sku
                    },
                    domProps: {
                      value: childProduct.products[0].variants[0].sku
                    }
                  }),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.number",
                        value: _vm.quantities[index],
                        expression: "quantities[index]",
                        modifiers: { number: true }
                      }
                    ],
                    staticClass: "child-proudcts__quantity-input",
                    attrs: {
                      name: "quantity",
                      type: "number",
                      min: _vm.packSize[index],
                      step: _vm.packSize[index],
                      "aria-label": "Quantity"
                    },
                    domProps: { value: _vm.quantities[index] },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.quantities,
                          index,
                          _vm._n($event.target.value)
                        )
                      },
                      blur: function($event) {
                        return _vm.$forceUpdate()
                      }
                    }
                  }),
                  !childProduct.products[0].tags
                    .join(",")
                    .toLowerCase()
                    .includes("restrict_web_sale")
                    ? _c(
                        "button",
                        {
                          class: `child-proudcts__add-to-cart-button button button--primary`,
                          attrs: {
                            disabled:
                              !childProduct.products[0].variants[0].available ||
                              childProduct.products[0].tags
                                .join(",")
                                .toLowerCase()
                                .includes("restrict_web_sale")
                          },
                          on: {
                            click: function($event) {
                              _vm.addToCart(
                                childProduct.products[0].variants[0].id,
                                childProduct,
                                _vm.quantities[index],
                                _vm.getMinQtyAboveOneCount(
                                  childProduct.products[0].tags
                                )
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              childProduct.products[0].variants[0].available
                                ? "Add to Cart"
                                : "Sold Out"
                            )
                          )
                        ]
                      )
                    : _c(
                        "button",
                        {
                          class: `child-proudcts__add-to-cart-button button button--primary`,
                          attrs: {
                            disabled:
                              !childProduct.products[0].variants[0].available ||
                              childProduct.products[0].tags
                                .join(",")
                                .toLowerCase()
                                .includes("restrict_web_sale")
                          },
                          on: {
                            click: function($event) {
                              return _vm.addToCart(
                                childProduct.products[0].variants[0].id,
                                childProduct
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              childProduct.products[0].variants[0].available
                                ? "CALL 800-MACTOOLS"
                                : "Sold Out"
                            )
                          )
                        ]
                      )
                ]
              )
            ])
          }),
          0
        ),
        _vm.isCollapsed
          ? _c(
              "div",
              {
                staticClass: "child-products__view-more",
                on: { click: _vm.hasMoreProductsProducts }
              },
              [
                _c("icon", {
                  staticClass: "child-products__view-more-button",
                  attrs: { name: "plus", size: "16px" }
                }),
                _c("span", { staticClass: "child-products__view-more-label" }, [
                  _vm._v(_vm._s(_vm.viewMoreLabel))
                ])
              ],
              1
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }